import React from 'react';
import { VStack, HStack, Text, Badge, BadgeText } from '@gluestack-ui/themed';
import { formatSlotDate, formatTimeRange } from '../utils/slotUtils';

/**
 * SlotHeader Component - Displays slot date and time information
 */
const SlotHeader = ({ slot }) => {
  const { timeRange, timezone } = formatTimeRange(slot.startTime, slot.endTime);

  return (
    <VStack space="xs">
      <Text size="md">{formatSlotDate(slot.startTime)}</Text>
      <HStack alignItems="center" space="$2">
        <Text size="xl" fontWeight="bold" color="$textDark900">
          {timeRange}
        </Text>
        <Badge size="sm" variant="solid" ml="$1">
          <BadgeText>{timezone}</BadgeText>
        </Badge>
      </HStack>
    </VStack>
  );
};

export default SlotHeader;
